import { Modal, MimaText, FlexButton } from '../../components';
import { ElectricBillContainer } from '../../containers';
import React from 'react';

function Utilities({
	closeModal,
	selectElectricBill,
	mainContents,
	payElectricBill,
	pinContent,
	setPinContent,
	goBack,
	needFeedback,
	setShowSurvey,
}) {
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			{mainContents && (
				<>
					<MimaText variant="subtitle" mb={4}>
						Pay Electricity Bill
					</MimaText>

					<FlexButton title="Electricity" mt={4} onClick={payElectricBill} />
					{/* <FlexButton title="Toll Fees" mt={4} /> */}
				</>
			)}

			{selectElectricBill && (
				<ElectricBillContainer
					closeModal={closeModal}
					pinContent={pinContent}
					setPinContent={setPinContent}
					needFeedback={needFeedback}
					setShowSurvey={setShowSurvey}
				/>
			)}
		</Modal>
	);
}

export default Utilities;
